import { Reveal } from '../components/Reveal';

const integrations = [
  { name: 'Epyx / 1Link', desc: 'Service, maintenance and repair network workflows' },
  { name: 'DVLA', desc: 'Direct link for MOT reminders and vehicle data' },
  { name: 'SMS & email', desc: 'Confirmations and updates sent automatically to drivers and suppliers' },
  { name: 'Telematics', desc: 'Live vehicle and location data fed into the vehicle record' },
  { name: 'Daily hire', desc: 'Hire requests raised, tracked and confirmed' },
  { name: 'Automated bookings', desc: 'Bookings placed directly from the app' },
];

export const Integrations = () => (
  <section id="integrations" className="scroll-mt-20 border-t border-[#E5E7EB] bg-[#F4F5F1] py-20 md:py-28" data-testid="integrations-section">
    <div className="container-relay grid grid-cols-1 gap-12 lg:grid-cols-12 lg:gap-10">
      <Reveal className="lg:col-span-4">
        <p className="eyebrow mb-4" data-testid="integrations-eyebrow">Connect before replacing</p>
        <h2 className="text-3xl font-bold tracking-tight text-[#111111] sm:text-4xl" data-testid="integrations-headline">
          Integrate with what you use.
        </h2>
        <p className="mt-5 text-base leading-relaxed text-[#6B7280]" data-testid="integrations-body">
          Relay connects the tools, suppliers and systems that already sit around your operation — so information
          flows, not people.
        </p>
        <p className="mt-6 text-sm leading-relaxed text-[#111111]" data-testid="integrations-promise">
          <span className="font-semibold text-[#0F5C4A]">If your operation runs on it, we can connect it.</span>{' '}
          Bespoke integrations are built as part of every implementation — at no extra cost to the way you work.
        </p>
      </Reveal>
      <div className="lg:col-span-8">
        <p className="font-op mb-4 text-[11px] font-semibold uppercase tracking-[0.22em] text-[#0F5C4A]" data-testid="integrations-api-header">
          Integrations &amp; API
        </p>
        <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3">
          {integrations.map((it, i) => (
            <Reveal key={it.name} delay={i * 0.07}>
              <div
                data-testid={`integration-${it.name.toLowerCase().replace(/[^a-z0-9]+/g, '-')}`}
                className="flex h-full flex-col gap-2.5 rounded-xl border border-[#E5E7EB] bg-white p-5 shadow-[0_4px_20px_rgba(16,24,40,0.04)]"
              >
                <span className="text-sm font-semibold tracking-tight text-[#111111]">{it.name}</span>
                <span className="text-[13px] leading-relaxed text-[#6B7280]">{it.desc}</span>
              </div>
            </Reveal>
          ))}
          <Reveal delay={0.45} className="sm:col-span-2 lg:col-span-3">
            <div
              className="flex h-full flex-col items-center justify-center gap-1.5 rounded-xl border border-dashed border-[#C6CCC5] px-6 py-7 text-center"
              data-testid="integration-more"
            >
              <span className="text-sm font-semibold text-[#111111]">Your system here</span>
              <span className="font-op text-[10px] uppercase tracking-[0.16em] text-[#6B7280]">
                We haven&rsquo;t come across a system we couldn&rsquo;t integrate yet
              </span>
            </div>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);
